import React, { useState } from "react";
import { StyledCouponForm, StyledGotACoupon } from "./plans.style";
import plansList from "./plansList";
import {formDataWithToken, wpUrl} from "../../services/globalService";

const CouponInput = ({ applyCoupon, setApplyCoupon, setPlans, coupon, setCoupon }) => {

  const [showCouponInput, setShowCouponInput] = useState(false);
  const [msg, setMsg] = useState("");

  const validateCoupon = async () => {
    if (coupon) {
      try {
        // check coupon
        const response = await formDataWithToken(wpUrl,{
          action: 'fxl_apply_coupon',
          coupon,
          plansList,
        });
        // if ok save plans with coupon
        setMsg("Coupon applied successfully");
        const plans = JSON.parse(response?.data?.data?.plans);
        setPlans(plans);
        return true;
      } catch (error) {
        console.error(error);
        setMsg(error.data.message);
        return false;
      }
    }
  };

  const handleCouponSubmit = async (e) => {
    e.preventDefault();
    const isCouponValid = await validateCoupon();
    if (isCouponValid) {
      setApplyCoupon(true);
    }
  };

  const inputForm = (
      <StyledCouponForm onSubmit={handleCouponSubmit}>
        <input
            type="text"
            value={coupon}
            onChange={(e) => setCoupon(e.target.value)}
            disabled={applyCoupon}
            placeholder="Coupon code"
        />
        <button type="submit" disabled={applyCoupon}>
          Let's go
        </button>
        {msg ? <p>{msg}</p> : null}
      </StyledCouponForm>
  );

  if (showCouponInput) {
    return inputForm;
  } else {
    return (
        <StyledGotACoupon onClick={() => setShowCouponInput(true)}>Got a coupon?</StyledGotACoupon>
    );
  }
};

export default CouponInput;
